import React, { useState, useEffect } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import OrganizationManager from '../components/OrganizationManager';
import { getOrganizations } from '../services/api';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

const OrganizationManagerPage = ({ user, onLogout }) => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const orgsData = await getOrganizations();
      setOrganizations(orgsData);
    } catch (error) {
      console.error('Error loading organizations:', error);
    } finally {
      setLoading(false);
    }
  };

  const refreshOrganizations = () => {
    getOrganizations().then(setOrganizations);
  };

  if (loading) {
    return (
      <DashboardLayout user={user} onLogout={onLogout}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 200,
          }}
        >
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Loading organizations...</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout user={user} onLogout={onLogout}>
      <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
        <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
          Organizations Management
        </Typography>
        <OrganizationManager
          organizations={organizations}
          onRefresh={refreshOrganizations}
        />
      </Box>
    </DashboardLayout>
  );
};

export default OrganizationManagerPage;
